import React, { useEffect, useState } from "react";
import {
  CircularProgress,
  Box,
  Dialog,
  Typography,
  Badge,
  IconButton
} from "@material-ui/core";
import LocalParkingIcon from "@material-ui/icons/LocalParking";
import dialogStyles from "../../pages/callpanel/components/Transfer/styles";
import CallInPark from "./CallInPark";
import useStyles from "../Header/styles";

export default function ParkCount(props) {
  const [queueDetailsFlag, setQueueFlag] = useState(false);
 var classesDialog = dialogStyles();
    var classes = useStyles();

  const showQueueDetails = (value) => {
    setQueueFlag(value);
  };

  return (
    <Box
      display="flex"
      alignItems="center"
      style={{ position: "relative", cursor: "pointer" }}
      title="Park Call"
    >
      <Badge
        badgeContent={props.value.length}
        color={props.value > 0 ? "secondary" : "primary"}
        overlap="circle"
        anchorOrigin={{
          vertical: "top",
          horizontal: "right"
        }}
      >
        <IconButton onClick={() => showQueueDetails(true)} style={{ padding: 6 }}>
          <LocalParkingIcon classes={{ root: classes.headerIcon }} />
        </IconButton>
      </Badge>

      {/* Modal Dialog */}
      <Dialog
        keepMounted
        aria-labelledby="customized-dialog-title"
        open={queueDetailsFlag}
        onClose={() => setQueueFlag(false)}
        className={classesDialog.DialogBox}
        maxWidth="md"
      >
        <CallInPark showQueueDetails={showQueueDetails} parkData = {props.value} />
      </Dialog>
    </Box>
  );
}
